import { render, staticRenderFns } from "./CalendarDetails.vue?vue&type=template&id=718d84b6"
import script from "./CalendarDetails.vue?vue&type=script&lang=js"
export * from "./CalendarDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports